export type VatCalculationMode = "VAT_EXCLUSIVE" | "VAT_INCLUSIVE";

export const DEFAULT_VAT_CALCULATION_MODE: VatCalculationMode = "VAT_INCLUSIVE";

/** VAT percentage choices shown in company forms (0–50 inclusive). */
export const VAT_PERCENTAGE_OPTIONS: readonly number[] = Array.from(
  { length: 51 },
  (_, index) => index
);

export const VAT_CALCULATION_MODE_OPTIONS: readonly {
  value: VatCalculationMode;
  labelKey: string;
  defaultLabel: string;
}[] = [
  {
    value: "VAT_INCLUSIVE",
    labelKey: "vat-calculation-mode-inclusive",
    defaultLabel: "VAT inclusive (price includes VAT)"
  },
  {
    value: "VAT_EXCLUSIVE",
    labelKey: "vat-calculation-mode-exclusive",
    defaultLabel: "VAT exclusive (VAT added on top)"
  }
];

export const withCompanyVatDefaults = <
  T extends { vatPercentage?: number; vatCalculationMode?: VatCalculationMode }
>(
  company: T
): T & { vatPercentage: number; vatCalculationMode: VatCalculationMode } => ({
  ...company,
  vatPercentage: company.vatPercentage ?? 18,
  vatCalculationMode: company.vatCalculationMode ?? DEFAULT_VAT_CALCULATION_MODE
});
